<template>
    <div class="m-vippack">

      <h5 class="title"></h5>

      <div class="vip-swiper">

        <!-- <div class="tab-hd" slot="pagination"></div>         -->

        <!-- <swiper ref="vipSwiper" :options="swiperOptions">
          <swiper-slide>
            <div class="vip-pack p-1">
                <p class="notice">购买后，可从往期鸡王系列换装礼包中自选1件</p>

                <div class="reward-view">
                    <ul>
                        <li v-for="(item,index) in pack_config['box_1']" :key="index">
                            <div class="reward-item"  @click="$item_tips(item.id)"><game-item :id="item.id" :num="item.num" :locked="true"></game-item></div>  
                        </li>
                    </ul>
                </div>

                <div class="u-btn apply apply-2399 dismiss" v-if="$store.state.account.gift32 == 4"></div> 
                <div class="u-btn apply apply-2399" v-else @click="apply_pack(32,2399)"></div>      
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="vip-pack p-2">
                <h6 class="title"></h6>

                <div class="reward-view">
                    <ul>
                        <li v-for="(item,index) in pack_config['box_2']" :key="index">
                            <div class="reward-item"  @click="$item_tips(item.id)"><game-item :id="item.id" :num="item.num" :locked="true"></game-item></div>                           
                        </li>
                    </ul>
                </div>

                <div class="u-btn apply apply-59 dismiss" v-if="($store.state.account.uflag & 64) == 64"></div>  
                <div class="u-btn apply apply-59" v-else @click="apply_pack(64,59)"></div>           
            </div>
          </swiper-slide>
        </swiper> -->

        <div class="vip-pack p-1">
            <p class="notice">鸡王系列换装包购买后，最多可买6次</br>可从往期鸡王系列换装礼包中自选1件。</p>

            <div class="reward-view">
                <ul>
                    <li v-for="(item,index) in pack_config['box_1']" :key="index">
                        <div class="reward-item"  @click="$item_tips(item.id)">
                            <game-item :id="item.id" :num="item.num" :locked="true"></game-item>
                            <div class="item-name">{{ item.name }}</div>
                        </div>  
                    </li>
                </ul>
            </div>

            <div class="u-btn apply apply-2399 dismiss" v-if="$store.state.account.gift32 == 4"></div> 
            <div class="u-btn apply apply-2399" v-else @click="apply_pack(32,2399)"></div>      
        </div>

      </div>        
    </div>
</template>

<style scoped>
.m-vippack{
    margin-top: 50px;
}

h5.title{
    width: 508px;
    height: 132px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-shop-3.png);
}

.vip-pack{
    /* position: relative;
    width: 710px;
    height: 748px;
    padding-top: 30px;
    margin-top: -200px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-vip-pack.png); */
}

.vip-pack::before{
    display: block;
    content: '';
}

.notice{
    margin-bottom: 15px;
    font-size: 24px;
    color: #ffdf93;
    text-align: center;
}

.reward-view{
    width: 727px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center 102px;
    background-image: url(~@/assets/images/bg-vip_shop.png);
}

.reward-view ul{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 0 30px;
}

.reward-view li{
    margin-bottom: 20px;
}

.reward-item{
    width: 196px;
    height: 195px;
    padding-top: 16px;
    background-image: url(~@/assets/images/bg-item_vip_shop.png);
}

.reward-item .pic{
    width: 92px;
    height: 92px;
    margin: 0 auto;
    border: 2px solid #b83e2b;
    box-sizing: content-box;
}

h6.title{
    width: 210px;
    height: 30px;
    margin: 0 auto 45px;
    background-image: url(~@/assets/images/title-pack-4.png);
}

.u-btn.apply{
    width: 349px;
    height: 98px;
    margin: 12px auto 0;
}

.u-btn.apply.apply-59{
    background-image: url(~@/assets/images/btn-apply-59.png);
}

.u-btn.apply.apply-59.dismiss{
    background-image: url(~@/assets/images/btn-apply-dismiss.png);
}

.u-btn.apply.apply-2399{
    background-image: url(~@/assets/images/btn-apply-2399.png);
}

.u-btn.apply.apply-2399.dismiss{
    background-image: url(~@/assets/images/btn-apply-dismiss.png);
}

.item-name{
    margin: 25px auto 0;
    font-size: 20px;
    font-weight: 700;
    color: #8d452c;
    text-align: center;
}
</style>

<style>
.vip-swiper .tab-hd {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.vip-swiper .tab-hd .u-btn{
    width: 332px;
    height: 82px;
    background-repeat: no-repeat;
}

.vip-swiper .u-btn.tab-1 {
    background-image: url(~@/assets/images/tab-pack-1.png);
}

.vip-swiper .u-btn.tab-1.active {
    background-image: url(~@/assets/images/tab-pack-1_act.png);
}

.vip-swiper .u-btn.tab-2 {
    background-image: url(~@/assets/images/tab-pack-2.png);
}

.vip-swiper .u-btn.tab-2.active {
    background-image: url(~@/assets/images/tab-pack-2_act.png);
}

</style>

<script>
export default {
    data (){
        return {
            swiperOptions : {
                pagination: {
                el: '.tab-hd',
                clickable: true,
                bulletClass: 'u-btn',
                bulletActiveClass: 'active',      
                renderBullet: function (index, className) {
                    return '<div class="' + className + ' tab-' + (index + 1) + '"></div>';
                },
                },        
            },
            pack_config : {
                'box_1' : [{name : '无敌鸡王冲锋包',id : 'KB55',num : 1},{name : '天命之子必胜包',id : 'KB56',num : 1},{name : '天命公主出巡包',id : 'KW23',num : 1},{name : '天命圣女守卫包',id : 'LP51',num : 1},{name : '枪王之王征战包',id : 'ME02',num : 1},{name : '天命大帝赐福包',id : 'KD85',num : 1},],
                'box_2' : [{name : '鸡王争霸换装体验包（7天）',id : 'LC12',num : 1},{name : '中级士兵卡',id : 'D355',num : 1},{name : '中级兵粮卡',id : 'D356',num : 1},{name : '免费技能随机卡3盘(3天）',id : 'Y548',num : 10}],
            },
        }
    },
    methods : {
        apply_pack(gid,cost){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(this.$store.state.account.gift32 == 4 && gid == 32)return this.$toast('无法再购买');
            if(((this.$store.state.account.uflag & gid) == gid) && gid != 32)return this.$toast('无法再购买');

            this.$comfirm_Modal({
                text : '购买该礼包吗？',
                gid : gid,
                num : 1,
                cost : cost,
            })            

            // this.$axios.post(globalThis.ajax_url_map.buy,{
            //     giftId : gid,
            // })
            // .then(
            //     res => {                   
            //         this.$success_Modal({text : '购买成功'});
            //         this.$update_userType(10)
            //     },
            //     rej => {
            //         let type = rej.code == 416 ? 2 : 1;
            //         type == 2 ? this.$error_Modal({text : rej.message , type : type}) : this.$toast(rej.message);
            //     },
            // )       
        },
    },      
}
</script>


// WEBPACK FOOTER //
// src/components/Shop/vippack.vue